module.exports = __webpack_public_path__ + "static/media/Illus-Diversity_2.0d300276.png";